// Bloc « Push » de la page Alarmes : mise en forme pure de GET /push-stats.
const LABELS = { ios: "iPhone", mac: "Mac", android: "Android", other: "Autres", none: "Sans accusé" };

export function pushSummary(stats) {
    const s = stats || {};
    const o = s.overall || null;
    const sent = o ? Number(o.sent) || 0 : 0;
    const rate = o && sent > 0 ? `${Math.round((Number(o.deliveryRate) || 0) * 100)} %` : "—";
    const delivery = (s.byPlatform || []).map((r) => ({
        label: LABELS[r.key] || r.key,
        sent: Number(r.sent) || 0,
        delivered: Number(r.delivered) || 0,
    }));
    const tokens = s.tokens || {};
    return {
        overall: { rate, sent, delivered: o ? Number(o.delivered) || 0 : 0 },
        delivery,
        ghosts: Number(tokens.ghost) || 0,
        healthy: Number(tokens.healthy) || 0,
        warnings: s.warnings || [],
    };
}

// Compteur de fantômes : jetons marqués dont le dernier envoi tombe dans la période (pas un stock total).
export const GHOST_COUNTER_LABEL = "Jetons fantômes (envoyés sur la période)";

// État d'affichage du bloc : en erreur, seule l'alerte s'affiche (jamais un résumé à zéro trompeur).
export function pushCardState(stats, error) {
    if (error) return "error";
    if (!stats) return "loading";
    return "ready";
}
